


















































































import {
  ComponentInternalInstance,
  computed,
  defineComponent,
  getCurrentInstance,
  nextTick,
  reactive,
  ref,
  toRefs,
  watch,
  set,
} from '@vue/composition-api';
import { LoadingIcon, DownloadIcon, UploadIcon } from 'tdesign-icons-vue';
import BScroll from '@better-scroll/core';
import PullDown from '@better-scroll/pull-down';
import PullUp from '@better-scroll/pull-up';
import MouseWheel from '@better-scroll/mouse-wheel';
import i18n, { i18n_t } from '@/locales/i18n';
import tips from '@/renderer/scripts/utils/tips';
import { SMH } from '@/renderer/scripts/smh';
import ipc from '@/renderer/scripts/utils/ipc';

BScroll.use(PullUp);
BScroll.use(PullDown);
BScroll.use(MouseWheel);
const THRESHOLD = 70;
const STOP = 56;

/**
 * 判断是否微信浏览器
 */
function isWxBrowser() {
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf('micromessenger') !== -1;
}
interface Props {
  showDownloadBtn: boolean;
  needLogin: boolean;
  listByPage: any[]; //  分页的源数据列表
  loadMore: boolean;
  pullList: Function | undefined;
  refreshList: Function | undefined;
  crumbs: Object[];
  crumbStartIndex: number;
}
export default defineComponent({
  components: {
    LoadingIcon,
    DownloadIcon,
    UploadIcon,
  },
  props: {
    showDownloadBtn: {
      type: Boolean,
      default: false,
    },
    needLogin: {
      type: Boolean,
      default: false,
    },
    crumbs: {
      type: Array,
      default: [],
    },
    listByPage: {
      type: Array,
      default: [],
    },
    crumbStartIndex: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    loadMore: {
      type: Boolean,
      default: false,
    },
    initScroll: {
      type: Function,
      required: false,
    },
    pullList: {
      type: Function,
      required: false,
    },
    refreshList: {
      type: Function,
      required: false,
    },
  },
  setup(props: Props, context) {
    // 当前组件
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const isInWxBrowser = isWxBrowser();
    const showHint = ref(isInWxBrowser);
    const mobileData = reactive<{
      selectedMap: Record<number, boolean>;
      list: SMH.SpaceFileItemData[];
    }>({
      selectedMap: [],
      list: [],
    });
    const disableBtn = computed(() => {
      const { selectedMap, list } = mobileData;
      const selectedList = Object.values(selectedMap).filter(v => v);
      const hasDirItem = Object.keys(selectedMap).some(index => selectedMap[+index] && list[+index].type === 'dir');
      const download = selectedList.length > 1 || selectedList.length === 0 || hasDirItem;
      const saveToNetDisc = selectedList.length === 0;
      return {
        download,
        saveToNetDisc,
      };
    });
    const state = reactive({
      pullDownState: 1,
      // 1->下拉可以刷新 2->松开立即刷新 3->正在刷新数据...
      pullUpState: props.loadMore ? 1 : 2, // 1->上拉加载更多 2->已经到底啦 3->正在加载数据...
    });

    let listBetterScroll: BScroll | null = null;
    const mobileBodyStyle = computed(() => {
      let height = window.innerHeight - 246;
      if (props.showDownloadBtn) {
        // 下载按钮被显示时高度要减 70
        height = window.innerHeight - 316;
      }
      const listItemHeight = 66;
      if (mobileData.list.length) {
        height = Math.min(height, (mobileData.list.length + 1) * listItemHeight);
      }
      return {
        height: `${height}px`,
      };
    });
    const isSelectedAll = computed(() => {
      const selectedList = Object.values(mobileData.selectedMap);
      return selectedList.length === mobileData.list.length && !selectedList.some(item => !item);
    });
    const methods = {
      initRenderer() {
        if (mobileData.list.length === 0 && props.listByPage.length > 0) {
          mobileData.list = [...props.listByPage];
        }
      },
      initListScroll() {
        if (vm.$store.getters.isMobile && context.refs.scrollList) {
          if (listBetterScroll) listBetterScroll.destroy();
          // 初始化列表滚动
          listBetterScroll = new BScroll(context.refs.scrollList as HTMLElement, {
            probeType: 3,
            click: false,
            preventDefault: false,
            specifiedIndexAsContent: 0,
            pullDownRefresh: {
              threshold: THRESHOLD,
              stop: STOP,
            },
            pullUpLoad: true,
            mouseWheel: true,
          });
          listBetterScroll.on('pullingDown', methods.pullingDownHandler);
          listBetterScroll.on('pullingUp', methods.pullingUpHandler);
          listBetterScroll.on('scroll', ({ y }: any) => {
            if (y > THRESHOLD) {
              state.pullDownState = 2;
            } else {
              state.pullDownState = 1;
            }
          });
        }
      },
      // 下拉刷新
      async pullingDownHandler() {
        if (props.refreshList) {
          methods.resetMobileData();
          state.pullDownState = 3;
          props.refreshList(() => {
            if (listBetterScroll) {
              listBetterScroll.finishPullDown();
            }
            setTimeout(() => {
              state.pullDownState = 1;
              if (listBetterScroll) {
                listBetterScroll.refresh();
              }
            }, 200);
          });
        }
      },
      // 上拉加载
      async pullingUpHandler() {
        if (props.pullList && props.loadMore) {
          state.pullUpState = 3;
          props.pullList(() => {
            mobileData.list.push(...props.listByPage);
            if (listBetterScroll) listBetterScroll.finishPullUp();
            setTimeout(() => {
              state.pullUpState = 1;
              if (listBetterScroll) listBetterScroll.refresh();
            }, 200);
          });
        } else if (!props.loadMore) {
          state.pullUpState = 2;
        }
      },
      resetMobileData() {
        mobileData.list = [];
        mobileData.selectedMap = {};
      },
      changePath(count: number) {
        this.resetMobileData();
        context.emit('change-path', count);
      },
      onDownload() {
        if (isInWxBrowser) {
          showHint.value = true;
          return;
        }
        if (props.needLogin) {
          tips.info(i18n_t('分享人设置了下载水印，请先登录后继续操作'));
          ipc.emit(ipc.RENDERER_EVENTS_MAP.LOGIN_DIALOG_SHOW);
          return;
        }
        const { selectedMap } = mobileData;
        const downloadList: any[] = [];
        const selectedNum = Object.keys(selectedMap).filter(index => selectedMap[+index]).length;
        if (selectedNum > 1) {
          tips.warning(i18n_t('当前仅支持下载单个文件'));
          return;
        }
        Object.keys(selectedMap).forEach(index => {
          const isSelected = selectedMap[+index];
          if (isSelected) {
            downloadList.push(mobileData.list[+index]);
          }
        });
        const includeFolder = downloadList.findIndex(item => item.type === 'dir') > -1;
        if (includeFolder) {
          tips.warning(i18n_t('当前不支持下载文件夹'));
          return;
        }
        if (downloadList.length > 0) {
          context.emit('download', downloadList);
        }
      },
      onSaveToNetDisc() {
        const selectedList = mobileData.list.filter((item, index) => mobileData.selectedMap[index]);
        context.emit('save', selectedList);
      },
      onTouchItem(e: TouchEvent, item: any, index: number) {
        const { target } = e;
        // 点击空白区域则选中
        if ((target as HTMLElement).className === 'list-item__content') {
          item.type !== 'dir' && set(mobileData.selectedMap, index, !mobileData.selectedMap[index]);
        } else {
          if (item.type === 'dir') {
            // 切换目录则重置移动端列表
            this.resetMobileData();
          }
          context.emit('open', item, index);
        }
      },
      onSelectAll() {
        const { value } = isSelectedAll;
        mobileData.list.forEach((item, index) => {
          set(mobileData.selectedMap, index, !value);
        });
      },
    };
    methods.initRenderer();
    watch(
      () => props.listByPage,
      newList => {
        if (mobileData.list.length === 0) {
          mobileData.list = [...newList];
          nextTick(() => {
            methods.initListScroll();
          });
        }
      },
    );
    const shadowCrumbs = computed(() => {
      const crumbs = props.crumbs
        .map((crumb, index) => ({
          ...crumb,
          step: index,
        }))
        .filter((crumb, index) => index >= props.crumbStartIndex || !index);
      if (crumbs.length <= 4) {
        return crumbs;
      }
      return [
        crumbs[0],
        crumbs[1],
        {
          name: '...',
          step: crumbs[crumbs.length - 2].step,
        },
        crumbs[crumbs.length - 1],
      ];
    });
    return {
      mobileBodyStyle,
      showHint,
      ...toRefs(mobileData),
      ...toRefs(state),
      disableBtn,
      ...methods,
      isSelectedAll,
      shadowCrumbs,
    };
  },
});
